export enum RoutePaths {
  // root paths
  ROOT = "/",
  WORKSPACE_ROOT = "/:workspaceSlug",

  // user feedback paths
  USER_FEEDBACK_MODULE_ROOT = "/:workspaceSlug/user-feedback",
  USER_FEEDBACK = "/:workspaceSlug/user-feedback/:appKey",
  USER_FEEDBACK_DETAILS = "/:workspaceSlug/user-feedback/:appKey/:userFeedbackKey",
  USER_FEEDBACK_LOGS = "/:workspaceSlug/user-feedback/:appKey/:userFeedbackKey/activity-history",
  USER_FEEDBACK_SHARE_SHAKE = "/:workspaceSlug/user-feedback/:appKey/share-shake",

  // crashes paths
  CRASH_MODULE_ROOT = "/:workspaceSlug/crash-reports",
  CRASH_REPORTS = "/:workspaceSlug/crash-reports/:appKey",
  CRASH_REPORT_ROOT = "/:workspaceSlug/crash-reports/:appKey/:crashReportKey",
  CRASH_REPORT_OVERVIEW = "/:workspaceSlug/crash-reports/:appKey/:crashReportKey/overview",
  CRASH_REPORT_EVENTS = "/:workspaceSlug/crash-reports/:appKey/:crashReportKey/events",
  CRASH_REPORT_EVENT = "/:workspaceSlug/crash-reports/:appKey/:crashReportKey/events/:crashReportEventId",
  CRASH_REPORT_LOGS = "/:workspaceSlug/crash-reports/:appKey/:crashReportKey/events/:crashReportEventId/activity-history",
  CRASH_REPORT_SHARE_SHAKE = "/:workspaceSlug/crash-reports/:appKey/share-shake",

  // users paths
  USERS_MODULE_ROOT = "/:workspaceSlug/users",
  USERS = "/:workspaceSlug/users/:appKey",
  USER_DETAILS = "/:workspaceSlug/users/:appKey/:userId",
  USERS_SHARE_SHAKE = "/:workspaceSlug/users/:appKey/share-shake",

  // releases paths
  RELEASES_MODULE_ROOT = "/:workspaceSlug/releases",
  RELEASES = "/:workspaceSlug/releases/:appKey",
  RELEASE_METRIC_ROOT = "/:workspaceSlug/releases/:appKey/:metricKey",
  RELEASE_METRIC_DATA = "/:workspaceSlug/releases/:appKey/:metricKey/data",
  RELEASE_METRIC_SCORE = "/:workspaceSlug/releases/:appKey/:metricKey/score",
  RELEASE_METRIC_GUARDRAILS = "/:workspaceSlug/releases/:appKey/:metricKey/guardrails",
  RELEASE_METRIC_ABOUT = "/:workspaceSlug/releases/:appKey/:metricKey/about",
  RELEASE_METRIC_METADATA_DIMENSIONS = "/:workspaceSlug/releases/:appKey/:metricKey/metadata-dimensions",

  // add app paths
  ADD_APP = "/:workspaceSlug/add-app",

  // administration paths
  ADMINISTRATION_ROOT = "/:workspaceSlug/administration",
  ADMINISTRATION_GENERAL = "/:workspaceSlug/administration/general",
  ADMINISTRATION_EXTENSIONS = "/:workspaceSlug/administration/extensions",
  ADMINISTRATION_WHITE_LABELING = "/:workspaceSlug/administration/white-labeling",
  ADMINISTRATION_MEMBERS = "/:workspaceSlug/administration/members",
  ADMINISTRATION_APPS = "/:workspaceSlug/administration/apps",
  ADMINISTRATION_APPS_GENERAL = "/:workspaceSlug/administration/apps/general",
  ADMINISTRATION_APPS_USER_FEEDBACK = "/:workspaceSlug/administration/apps/feedback",
  ADMINISTRATION_APPS_CRASHES = "/:workspaceSlug/administration/apps/crashes",
  ADMINISTRATION_APPS_USERS = "/:workspaceSlug/administration/apps/users",
  ADMINISTRATION_APPS_GENERAL_KEY = "/:workspaceSlug/administration/apps/general/:appKey",
  ADMINISTRATION_APPS_USER_FEEDBACK_KEY = "/:workspaceSlug/administration/apps/feedback/:appKey",
  ADMINISTRATION_APPS_CRASHES_KEY = "/:workspaceSlug/administration/apps/crashes/:appKey",
  ADMINISTRATION_APPS_USERS_KEY = "/:workspaceSlug/administration/apps/users/:appKey",

  ADMINISTRATION_BILLING = "/:workspaceSlug/administration/billing",

  // info paths
  INFO_ROOT = "/:workspaceSlug/info",
  VIDEOS_ROOT = "/:workspaceSlug/info/videos",
  INFO_PRODUCT_MANAGERS = "/:workspaceSlug/info/videos/product-managers",
  INFO_APP_DEVELOPERS = "/:workspaceSlug/info/videos/app-developers",
  INFO_APP_TESTERS = "/:workspaceSlug/info/videos/app-testers",
  INFO_CUSTOMER_SUPORT = "/:workspaceSlug/info/videos/customer-support",
  INFO_ALL = "/:workspaceSlug/info/videos/all",
  FEATURES_ROOT = "/:workspaceSlug/info/features",
  FEATURES_LATEST = "/:workspaceSlug/info/features/latest",
  FEATURES_POPULAR = "/:workspaceSlug/info/features/popular",
  QUICK_LINKS = "/:workspaceSlug/info/quick-links",
  APP_DEVELOPMENT = "/:workspaceSlug/info/app-development",

  //common comments
  ADMINISTRATION_COMMON_COMMENTS = "/:workspaceSlug/administration/common-comments",

  // no subscription
  NO_SUBSCRIPTION = "/:workspaceSlug/no-subscription",

  // account paths
  ACCOUNT_ROOT = "/:workspaceSlug/account",
  ACCOUNT_PERSONAL_INFO = "/:workspaceSlug/account/info",
  ACCOUNT_NOTIFICATIONS = "/:workspaceSlug/account/notifications",

  // create / join workspace paths
  CREATE_WORKSPACE = "/create-workspace",
  JOIN_WORKSPACE = "/join-workspace",

  // link confirmation paths
  ADMINISTRATION_DOMAIN_VERIFICATION = "/verify-domain",
  ADMINISTRATION_APP_DOMAIN_VERIFICATION = "/verify-app-domain",
  ACCOUNT_NOTIFICATIONS_CONFIRMATION = "/:workspaceSlug/account/notifications/confirm",
  WORKSPACE_JOIN_INVITATION = "/invitation",
  CHANGE_EMAIL_CONFIRMATION = "/change-email-confirmation",
  CANNY_AUTH = "/canny-auth",

  // public paths
  SIGNIN = "/signin",
  SIGNUP = "/signup",
  AUTHORIZE = "/oauth/authorize",
  CONFIRM_SIGNUP = "/confirmation",
  FORGOT_PASSWORD = "/forgot-password",
  RESET_PASSWORD = "/reset-password",
  CHROME_EXTENSION_WELCOME = "/welcome",

  // integration activation
  INTEGRATION_ACTIVATION = "/integration-activation",

  // not found path
  NOT_FOUND = "*",
}

export const MetricKeys = {
  releaseHealth: "release-health",
  crashFreeSessions: "crash-free-sessions",
  appHangFreeSessions: "app-hang-free-sessions",
  resolutionRate: "resolution-rate",
  endpointHealth: "endpoint-health",
  networkSpeed: "network-speed",
  testingCoverage: "coverage",
  currentDuration: "current-duration",
  releaseDateEstimate: "release-date-estimate",
  mttr: "mean-time-to-resolve",
};
